import axios from 'axios'
import router from '@/router';
import store from '@/store/index';
import { runtimeConfig } from '@/config/runtimeConfig'

export default () => {
	const instance = axios.create({
		baseURL: runtimeConfig.apiUri,
		withCredentials: false,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	})

	instance.interceptors.response.use(
		response => {
			return response
		},
		async error => {
			const originalRequest = error.config
			const access_token = localStorage.getItem("token")

			if (!error.response) {
				return Promise.reject(error)
			}

			if (error.response.status !== 401) {
				return Promise.reject(error)
			}

			if (
				error.response.status === 401 &&
				access_token &&
				!originalRequest._retry
			) {
				originalRequest._retry = true
				return instance(originalRequest)
			}

			if (
				error.response.status === 401 &&
				access_token &&
				!originalRequest._retryRevoke
			) {
				originalRequest._retryRevoke = true

				let newToken = await store.dispatch("dc4/revoke")

				if (newToken) {
					originalRequest.headers.Authorization = "Bearer " + newToken
					return instance(originalRequest)
				}
			}

			if (error.response.status === 401) {
				router.push("/oryx/login")
			}

			return Promise.reject(error)
		}
	)

	instance.interceptors.request.use(async config  => {
		let newToken = localStorage.getItem("token");
		let auth = null
		if(config.headers.common.Authorization){
			auth = config.headers.common.Authorization.split("Bearer ")[1]
		}
		if (newToken && auth && newToken != auth){
			config.headers.common.Authorization = "Bearer " + newToken
		}

		return config
	}, error => {
		return Promise.reject(error)
	})

	return instance
}